var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSuccessmedium(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 142,
    viewBox: "0 0 142 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 141,
    height: 44,
    rx: 7.5,
    fill: "#212731",
    stroke: "url(#paint0_linear_621_521)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M72.5 36.4915C72.5 36.3113 72.5969 36.1451 72.7537 36.0563L82.8489 30.3421C83.0043 30.2541 83.1948 30.2557 83.3487 30.3462L87.4537 32.761C87.7855 32.9561 87.7816 33.4371 87.4468 33.6269L73.2466 41.6767C72.9133 41.8657 72.5 41.6249 72.5 41.2418V36.4915Z",
    fill: "url(#paint1_linear_621_521)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M52 13.1576C52 12.7746 52.413 12.5338 52.7463 12.7225L57.0463 15.1564C57.2031 15.2452 57.3 15.4114 57.3 15.5916V27.6085C57.3 27.7887 57.2031 27.9549 57.0463 28.0437L52.7463 30.4776C52.413 30.6663 52 30.4255 52 30.0425V13.1576Z",
    fill: "url(#paint2_linear_621_521)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M72.7541 7.04352C72.5971 6.95484 72.5 6.78849 72.5 6.60816V1.85756C72.5 1.47456 72.913 1.23376 73.2463 1.42243L87.646 9.5732C87.981 9.76284 87.985 10.2441 87.6532 10.4393L83.5484 12.8539C83.3947 12.9443 83.2044 12.946 83.049 12.8582L72.7541 7.04352Z",
    fill: "url(#paint3_linear_621_521)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M54.5654 10.3353C54.228 10.1435 54.2283 9.6571 54.5659 9.4657L68.7532 1.42322C69.0865 1.23427 69.4998 1.47504 69.4998 1.85819V6.60607C69.4998 6.78751 69.4015 6.95471 69.243 7.04295L59.1456 12.6632C58.993 12.7481 58.8071 12.7473 58.6553 12.661L54.5654 10.3353Z",
    fill: "url(#paint4_linear_621_521)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M84.9478 27.8449C84.7944 27.7552 84.7002 27.5909 84.7002 27.4133V15.8916C84.7002 15.7115 84.7971 15.5452 84.9539 15.4565L89.2539 13.0225C89.5872 12.8339 90.0002 13.0747 90.0002 13.4577V29.9284C90.0002 30.3146 89.5811 30.555 89.2478 30.36L84.9478 27.8449Z",
    fill: "url(#paint5_linear_621_521)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M54.6633 33.7307C54.326 33.5404 54.3237 33.0556 54.6591 32.8621L58.8521 30.443C59.0056 30.3544 59.1946 30.3537 59.3487 30.4412L69.2466 36.0564C69.4032 36.1452 69.4999 36.3113 69.4999 36.4913V41.2439C69.4999 41.6266 69.0876 41.8674 68.7542 41.6794L54.6633 33.7307Z",
    fill: "url(#paint6_linear_621_521)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M60.7998 27.3071L60.7998 15.8905L70.9998 10.0755L81.1998 15.8905V27.3071L70.9998 33.0268L60.7998 27.3071Z",
    fill: "url(#paint7_linear_621_521)",
    stroke: "url(#paint8_linear_621_521)",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_621_521",
    x1: 71,
    y1: 0,
    x2: 71,
    y2: 45,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#57796B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#57796B",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_621_521",
    x1: 72.9344,
    y1: 38.3168,
    x2: 84.9203,
    y2: 31.2638,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.365057,
    stopColor: "#54BD23"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#90F243"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_621_521",
    x1: 54.2998,
    y1: 29.5715,
    x2: 61.3814,
    y2: 25.716,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.375473,
    stopColor: "#90F243"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#54BD23"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_621_521",
    x1: 86,
    y1: 11.5,
    x2: 72.7937,
    y2: 4.38272,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.365057,
    stopColor: "#54BD23"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#90F243"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_621_521",
    x1: 70,
    y1: 3,
    x2: 56.2252,
    y2: 11.8506,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.365057,
    stopColor: "#54BD23"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#90F243"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_621_521",
    x1: 87,
    y1: 29.5001,
    x2: 94.0103,
    y2: 25.5996,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.365057,
    stopColor: "#54BD23"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#90F243"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_621_521",
    x1: 67.1452,
    y1: 40.625,
    x2: 54.175,
    y2: 33.6507,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.432765,
    stopColor: "#90F243"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#54BD23"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_621_521",
    x1: 60.892,
    y1: 25.9382,
    x2: 79.9042,
    y2: 18.4084,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.365057,
    stopColor: "#54BD23"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#90F243"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_621_521",
    x1: 70.9998,
    y1: 9.5,
    x2: 70.9998,
    y2: 33.6,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccessmedium);
export default __webpack_public_path__ + "static/media/successmedium.c2dae7ea5245fc33beeb92b46bac15a5.svg";
export { ForwardRef as ReactComponent };